import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DraftPage from './pages/DraftPage';
import SuccessPage from './pages/SuccessPage'; // Importação da página de sucesso
import './index.css';

// Componente simples para verificar se o usuário está logado
const ProtectedRoute = ({ children }) => {
  // --- CORREÇÃO CRÍTICA: Mudamos de 'accessToken' para 'token' ---
  const token = localStorage.getItem('token');
  
  if (!token) {
    // Se não tiver token, manda para a página de login
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rota 1: Página de Login */}
        <Route path="/login" element={<LoginPage />} />

        {/* Rota 2: Página do Formulário (Protegida) */}
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <DraftPage />
            </ProtectedRoute>
          } 
        />

        {/* Rota 3: Página de Sucesso (Protegida) */}
        <Route 
          path="/success" 
          element={
            <ProtectedRoute>
              <SuccessPage />
            </ProtectedRoute>
          } 
        />
        
        {/* Qualquer outra rota volta para o login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;